export const DOCS = {
  PRIVACY_POLICY: '1jGYXAFVmFSnXAhGwel41pNSIjRGwPkuh',
  COOKIE_POLICY: '1Wg3Uqvv3_InxGli1lfV5-s0pXS0pS4Ic',
  PROCESSING_PERSONAL_DATA_CONSENT: '1-KxUm-xJGh_tKqufjiPmH3bGZt4BUTuH',
  USER_AGREEMENT: '1k6A53BAZpepWNJC1BnlsIkv2oSVjdqvJ',
};
